import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { StateController } from "../state";
import { logotype } from "../svg";

@customElement("umb-market-footer")
export class UmbMarketFooter extends LitElement {
  render() {
    if (StateController.isEmbedView || StateController.current.isBackoffice) {
      return null;
    }

    return html`
      <footer>
        <div id="content" class="padded">
          <div id="dinkus">
            ${logotype}
            <h2>
              Loved by developers.<br />Used by thousands around the world.
            </h2>
          </div>
          <div id="text">
            <p>
              One of the biggest benefits of using Umbraco is that we have the
              friendliest Open Source community on this planet. A community
              that's incredibly pro-active, extremely talented and helpful.
            </p>
            <p>
              If you get an idea for something you would like to build in
              Umbraco, chances are that someone has already built it. Umbraco
              Marketplace is your answer.
            </p>
          </div>
          <div id="buttons">
            <umb-market-button
              href="https://docs.umbraco.com/umbraco-dxp/marketplace/listing-your-package"
              target="_blank"
              >List my package</umb-market-button
            >
            <umb-market-button href="/validate"
              >Validation tools</umb-market-button
            >
            <umb-market-button
              href="https://umbraco.com/case-studies-testimonials/"
              target="_blank"
              >Case studies</umb-market-button
            >
            <umb-market-button
              href="https://umbraco.com/explore-umbraco-benefits/"
              target="_blank"
              >Why choose Umbraco?</umb-market-button
            >
          </div>
        </div>
        <div id="sidebarTop" class="sidebar padded">
          <div>
            <h3>Last updated</h3>
            <umb-market-tasks-timer></umb-market-tasks-timer>
          </div>
        </div>
        <div id="sidebarBottom" class="sidebar padded">
          <div>
            <h3>Resources</h3>
            <ul id="sidebarLinks">
              <li>
                <a
                  href="https://umbraco.com/about-us/trust-center/privacy-and-umbraco/privacy-statement/"
                  >Privacy</a
                >
              </li>
              <li>
                <a href="/cookies">Cookies</a>
              </li>
              <li>
                <a href="/acceptable-use">Acceptable Use Policy</a>
              </li>
              <li>
                <a
                  href="https://github.com/umbraco/Umbraco.Marketplace.Issues/issues/"
                  >Report an issue</a
                >
              </li>
            </ul>
          </div>
        </div>
      </footer>
    `;
  }

  static styles = [
    css`
      :host {
        display: flex;
        justify-content: center;
        width: 100%;
      }

      footer {
        box-sizing: border-box;
        width: 100%;
        max-width: var(--max-width);
        margin: var(--xxl-spacer) var(--m-spacer);
        display: grid;
        grid-template-columns: 100%;
        border: 1px solid var(--color-border);
        border-radius: 22px;
        font-size: 16px;
      }

      @media (min-width: 1300px) {
        footer {
          grid-template-columns: auto auto;
        }
      }

      .padded {
        padding: 40px;
      }

      @media (min-width: 767px) {
        .padded {
          padding: 60px;
        }
      }

      #content {
        grid-row-end: span 2;
      }

      .sidebar {
        border-top: 1px solid var(--color-border);
        display: flex;
        flex-direction: column;
        gap: var(--xl-spacer);
      }

      @media (min-width: 1300px) {
        #sidebarTop {
          border-top: 0;
        }

        .sidebar {
          border-left: 1px solid var(--color-border);
        }
      }

      #dinkus {
        display: flex;
        align-items: flex-start;
        gap: var(--l-spacer);
      }

      #dinkus svg {
        height: 52px;
        flex: 0 0 52px;
      }

      h2,
      h3 {
        color: var(--uui-color-default);
        margin-top: 0;
        font-weight: 400;
      }

      h2 {
        font-size: 22px;
        line-height: 29px;
      }

      h3 {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: var(--l-spacer);
      }

      p:last-child {
        margin-bottom: 0;
      }

      #buttons {
        display: flex;
        gap: 2px;
        flex-direction: column;
        margin-top: var(--l-spacer);
      }

      #buttons umb-market-button {
        font-weight: 500;
        font-size: 16px;
      }

      @media (min-width: 767px) {
        #buttons {
          flex-direction: row;
        }

        #buttons umb-market-button {
          border-radius: 0;
        }

        #buttons umb-market-button:first-child {
          border-top-left-radius: var(--xs-spacer);
          border-bottom-left-radius: var(--xs-spacer);

          padding-left: 14px;
        }

        #buttons umb-market-button:last-child {
          border-top-right-radius: var(--xs-spacer);
          border-bottom-right-radius: var(--xs-spacer);

          padding-right: 14px;
        }
      }

      @media (min-width: 1024px) {
        #dinkus svg {
          height: 100px;
          flex: 0 0 100px;
        }

        h2 {
          font-size: var(--h2-font-size);
          line-height: 1.3;
        }

        h3 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: var(--l-spacer);
        }
      }

      #sidebarLinks {
        display: flex;
        gap: var(--s-spacer);
        flex-direction: row;
        margin: 0;
        list-style: none;
        padding: 0;
      }

      #sidebarLinks li {
        flex: 1 0 auto;
      }

      #sidebarLinks a {
        color: var(--uui-color-text);
        text-decoration: none;
        background-image: linear-gradient(currentColor, currentColor);
        background-size: 100% 1px;
        background-position: bottom;
        background-repeat: no-repeat;
      }

      #sidebarLinks a:hover {
        color: var(--uui-color-default);
      }
    `,
  ];
}
